<template>
  <div class="home-page">
    <TopBanner />
    <div class="tit-box">
      <div class="top">
        <div style="display: flex; align-items: center">
          <img src="@/assets/image/logo2.png" style="width: 64px" />
          <span style="margin-left: 20px">企信链平台</span>
        </div>
        <span style="font-size: 36px">（企业版）</span>
      </div>
      <div class="btn">
        <div style="display: flex; align-items: center">精准匹配<span class="line"></span>让客户拥有更低成本，</div>
        <div style="padding-left: 234px">让供应商赢得更公平</div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";

export default {
  name: "Home",
  components: {
    TopBanner,
  },
};
</script>

<style scoped>
.home-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  /* background: url("~@/assets/image/loginPageBackground.png") no-repeat center center; */
  background: url("~@/assets/image/loginPageBackground3.png") no-repeat center center;
  background-size: cover;
}
.tit-box {
  position: fixed;
  left: 20%;
  top: 20%;
}
.top {
  line-height: normal;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 94px;
  color: #333333;
  letter-spacing: 4px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: flex;
  align-items: baseline;
}
.btn {
  line-height: normal;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 36px;
  color: #1869ff;
  letter-spacing: 4px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.line {
  display: inline-block;
  width: 74px;
  height: 4px;
  background-color: #1869ff;
}
</style>
